export interface UserDetails {
  personGuid: string;
  firstName: string;
  lastName: string;
  nnaId: number;
  email: string;
  orderGuid: string;
  isB2B: boolean;
}

export const mockUser: UserDetails = {
  firstName: "Roberto",
  lastName: "Haynes",
  nnaId: 847709471,
  orderGuid: "CF0B1C68-906B-D8A2-9D5F-E1B85B590658",
  personGuid: "B40CB2A4-4D1D-4713-9358-3D705A4B2267",
  email: "",
  isB2B: true
};
